/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Transcript_Unknown_SpeakerInputs */



/**
* | output |
* | --- |
* | "Unknown speaker" |
*
* @param {Meeting_Transcript_Unknown_SpeakerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_transcript_unknown_speaker = /** @type {((inputs?: Meeting_Transcript_Unknown_SpeakerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Transcript_Unknown_SpeakerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Onbekende spreker")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Locuteur inconnu")
	return /** @type {LocalizedString} */ ("Unknown speaker")
});